<template>
  <div class="action-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="640px" :before-close="handleClose"
               :close-on-click-modal="false" top="20px">
      <el-form ref="form" :model="params" :rules="rules" label-width="140px">
        <el-form-item label="用户ID:" prop="uid">
          <el-input v-model="params.uid" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="观影券金额:" prop="goldVideoCouponNum">
          <el-input type="number" v-model="params.goldVideoCouponNum" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="赠送观影券数量:" prop="num">
          <el-input type="number" v-model="params.num" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div class="flex just-center">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="handleAddCoupon()" :loading="flag" size="small">添加观影券</el-button>
      </div>
      <div class="mt-20 mb-10 line"></div>
      <div v-if="videoCoupons && videoCoupons.length > 0">
        <table class="tablebox">
          <thead>
          <tr>
            <th>观影券面值</th>
            <th>是否使用</th>
            <th>获取方式</th>
            <th>获取时间</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in videoCoupons" :key="index">
            <td>{{ item.num }}</td>
            <td>{{ item.used ? "已使用" : "未使用" }}</td>
            <td>
              <span v-if="item.source=='VIP'">购买VIP所得</span>
              <span v-if="item.source=='ADMIN'">后台添加所得</span>
              <span v-if="item.source=='PRIZE'">积分兑换所得</span>
              <span v-if="item.source=='SIGN'">签到赠送所得</span>
            </td>
            <td>{{ item.createdAt | changeDate }}</td>
            <td>
              <el-button size="mini" @click="handleDel(item.id)">删除</el-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="flex just-center pd10" style="background: #eee;padding:30px;">
        用户暂无观影券
      </div>
    </el-dialog>

  </div>
</template>
<script>
import API from "@/api";

export default {
  data() {
    return {
      dialogVisible: false,
      title: '添加观影券',
      // 提交状态
      flag: false,
      id: '',
      videoCoupons: [],
      // 回复评论的参数
      params: {
        uid: '',
        num: 1,
        goldVideoCouponNum: 100
      },
      // 表单验证规则
      rules: {
        uid: [
          {required: true, message: '请输入用户ID', trigger: 'blur'},
        ],
        num: [
          {required: true, message: '请输入赠送数量', trigger: 'blur'},
        ],
      }
    }
  },
  methods: {
    async handleLoadData(uid) {
      const res = await API.CouponList(uid)
      this.videoCoupons = res.data
    },
    async handleDel(id) {
      this.$confirm("您确定要删除当前项吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.CouponDel(id).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.handleLoadData(this.params.uid);
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    handleAddCoupon() {
      const params = this.params
      params.num = Number(params.num) || 1
      params.goldVideoCouponNum = Number(params.goldVideoCouponNum) || 100
      API.movieCert(params)
          .then(res => {
            if(res.code === 200){
              this.$message.success('添加观影券成功！')
              this.handleLoadData(this.params.uid);
            }else {
              this.$message.error('操作失败，请重试')
            }
          })
          .catch(() => {
            this.$message.error('操作失败，请重试')
          })
          .finally(() => {
            this.params.content = ''
          })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.$emit('handleList')
      this.params = {
        uid: '',
        content: ""
      }
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true
      this.params = {
        uid: data.uid,
        num: 1,
        goldVideoCouponNum: 100
      }
      this.handleLoadData(data.uid);
    }
  }
}
</script>

<style lang="scss" scoped>
.tablebox {
  width: 100%;
  border-collapse: collapse;
}

.tablebox td,
.tablebox th {
  text-align: center;
  border: 1px solid #ddd;
  padding: 6px;
}

</style>
